import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Segmented } from '@/components/common';

export type HomeTab = 'patients' | 'bookings';

/** The home screen's open tab, kept on the device. */
export const HOME_TAB_KEY = 'dentlog.home.tab';

/**
 * "Patients | Bookings": the home screen's two panes as tabs, on phones and
 * tablets in portrait (hidden where both panes show side by side).
 */
export function HomeTabs(p: {
  value: HomeTab;
  onChange: (tab: HomeTab) => void;
  className?: string;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <div className={`home__tabs ${p.className ?? ''}`}>
      <Segmented
        label={t('home.tabs')}
        value={p.value}
        onChange={p.onChange}
        options={[
          { value: 'patients', label: t('home.patients') },
          { value: 'bookings', label: t('home.bookings') },
        ]}
      />
      {p.children}
    </div>
  );
}
